import {BrandFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterFlyoutBrand} from '@aboutyou/ui-components';
import React from 'react';
import {useBrandSection} from '../../shared/useBrandFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: BrandFilterSection;
  hide: VoidFunction;
  submit: VoidFunction;
  isOpen: boolean;
  open: VoidFunction;
  setFilter: ({
    filterId,
    filterSection,
    filterSlug,
  }: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
};

export const FilterSectionBrand: React.FC<Props> = ({
  activeFilters,
  data,
  hide,
  isOpen,
  open,
  setFilter,
  submit,
}) => {
  const {label} = data;
  const {
    activeSlugFilters,
    normalizedBrandGroups,
    excludedBrands,
    favoriteBrandsFilterActive,
    normalizedHighlightedBrands,
    highlightedBrandsLabel,
    highlightedBrandsType,
    onBrandClick,
    handleAllFavoriteBrandsToggle,
    handleSingleFavoriteBrandClick,
  } = useBrandSection({data, setFilter, activeFilters});

  return (
    <FilterFlyoutBrand
      activeBrandIds={activeSlugFilters}
      brandGroups={normalizedBrandGroups}
      excludedHighlightedBrands={excludedBrands}
      favoriteBrandsActive={favoriteBrandsFilterActive}
      hide={hide}
      submit={submit}
      highlightedBrands={normalizedHighlightedBrands}
      highlightedBrandsLabel={highlightedBrandsLabel}
      highlightedBrandsType={highlightedBrandsType}
      isOpen={isOpen}
      label={label}
      onBrandClick={onBrandClick}
      onFavoriteBrandsToggle={handleAllFavoriteBrandsToggle}
      onHighlightedBrandClick={(id, itemSlug) =>
        handleSingleFavoriteBrandClick(id, itemSlug)
      }
      open={open}
    />
  );
};
